export default {
  browse: {
    en: 'Browse Scentbird select',
  },
  browseSaks: {
    en: 'Browse Saks select',
  },
}
